import React from 'react';
import PermissionMenu from './PermissionMenu';

const PermissionMenus = ({ onChangeInput, formData }) => {
  const menus = [
    { name: 'tableau_de_board', label: 'Tableau de bord', actions: ['read'] },
    { name: 'produit', label: 'Produits', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'variante', label: 'Variantes', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'depot', label: 'Dépôts', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'stock', label: 'Stock', actions: ['read', 'edit', 'write'] },
    { name: 'transfert', label: 'Transferts de stock', actions: ['read', 'write'] },
    { name: 'caisse', label: 'Caisse', actions: ['read', 'edit', 'write'] },
    { name: 'liste_caisses', label: 'Liste des caisses', actions: ['read', 'print'] },
    { name: 'chiffre_affaires_caisse', label: 'Chiffre d\'affaires caisse', actions: ['read'] },
    { name: 'retour_recu', label: 'Retour reçu', actions: ['read', 'write'] },
    { name: 'tva', label: 'TVA', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'remises', label: 'Remises', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'coupons', label: 'Coupons', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'clients', label: 'Clients', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'marque', label: 'Marques', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'fournisseur', label: 'Fournisseurs', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'commande', label: 'Commandes', actions: ['read', 'delete', 'write', 'edit', 'readOne', 'print', 'importExcel', 'export', 'status', 'follow', 'sync'] },
    { name: 'platforme', label: 'Plateformes', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'echange', label: 'Échanges', actions: ['read', 'delete', 'write'] },
    { name: 'charges', label: 'Charges', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'achat', label: 'Achats', actions: ['read', 'edit', 'delete', 'write'] },
    { name: 'reglement_fournisseur', label: 'Règlement fournisseur', actions: ['read', 'delete', 'write'] },
    { name: 'consommation_fournisseur', label: 'Consommation fournisseur', actions: ['read'] },
    { name: 'import_de_contacts', label: 'Import contacts', actions: ['write'] },
    { name: 'facebook_leads', label: 'Facebook Leads', actions: ['read', 'write'] },
    { name: 'paramètres', label: 'Paramètres', actions: ['read', 'write'] },
    { name: 'profil', label: 'Profil', actions: ['read', 'write'] },
    { name: 'code_promotionnel', label: 'Codes promo', actions: ['read', 'edit', 'delete', 'write'] },
  ];

  // Toggle all permissions for a menu
  const handleToggleAll = (menu, allChecked) => {
    menu.actions.forEach(action => {
      const permKey = `Menu_${menu.name}_${action}`;
      const currentlyChecked = formData.permission?.includes(permKey);
      if (allChecked && currentlyChecked) {
        // Uncheck
        onChangeInput({ target: { name: `${menu.name}__${action}`, checked: false, type: 'checkbox' } });
      } else if (!allChecked && !currentlyChecked) {
        // Check
        onChangeInput({ target: { name: `${menu.name}__${action}`, checked: true, type: 'checkbox' } });
      }
    });
  };

  return (
    <div className="space-y-3 pr-1">
      {menus.map((menu) => (
        <PermissionMenu
          key={menu.name}
          menu={menu}
          formData={formData}
          onChangeInput={onChangeInput}
          onToggleAll={handleToggleAll}
        />
      ))}
    </div>
  );
};

export default PermissionMenus;